import { createSelector } from '@reduxjs/toolkit';

import type { GatewayCreditselectionService } from 'commonTypes/api/gatewayCreditselectionService';
import { SCENARIO_STEP } from 'commonTypes/api/scenarios/BaseTypes';

import { getScenario } from 'entities/scenario';
import { collectWLOtherDataSelector } from 'entities/whiteLabels';

export const selectCreditSelectionPreapprovalSearchOtherParams = createSelector(
  getScenario,
  collectWLOtherDataSelector,
  (
    scenario,
    otherData,
  ): Pick<GatewayCreditselectionService.PreApprovalsSearchRequest, 'isFullProfile' | 'other'> | undefined => {
    if (!scenario?.step || scenario?.step === SCENARIO_STEP.CREDIT_SELECTION) {
      return {
        isFullProfile: true,
        other: otherData,
      };
    }

    return undefined;
  },
);
